import { helper } from '@ember/component/helper';
import { accounting } from 'accounting';

export default helper(function ([val]: string[]) {
  if (val == null) {
    val = '';
  }
  let precision = 0;
  let decimalsMatch = val.toString().match(/\..+$/);
  if (decimalsMatch) {
    precision = decimalsMatch[0].length - 1;
  }
  return accounting.formatNumber(val, precision);
});
